// The courses-project session as React state, plus the fallback sign-in.
// `user` is null until getCoursesAuth().currentUser exists.

import { useEffect, useState } from "react";
import type { User } from "firebase/auth";
import { COURSES_ENABLED } from "../config/env";
import { errorText, onCoursesAuthChange, signInToCourses } from "../services/courses/auth";

export interface CoursesAuthState {
  user: User | null;
  loading: boolean;
  signingIn: boolean;
  error: string | null;
  signIn: () => Promise<void>;
}

export function useCoursesAuth(): CoursesAuthState {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(COURSES_ENABLED);
  const [signingIn, setSigningIn] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    return onCoursesAuthChange((u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  async function signIn() {
    setSigningIn(true);
    setError(null);
    try {
      await signInToCourses();
    } catch (e) {
      setError(errorText(e));
    } finally {
      setSigningIn(false);
    }
  }

  return { user, loading, signingIn, error, signIn };
}
